import React, {useState, useCallback} from 'react'
import cn from 'classnames'

type AlertType = 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark'

interface AlertProps {
  type: AlertType
  children: React.ReactNode
  dismissible?: boolean
  onDismiss?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  className?: string
}

export default function Alert({
  type,
  children,
  dismissible,
  onDismiss,
  className,
}: AlertProps) {
  const [dismissed, setDismissed] = useState(false)

  const defaultOnDismiss = useCallback(() => {
    setDismissed(true)
  }, [setDismissed])

  if (dismissed) {
    return null
  }

  const isDismissible = !!(dismissible || onDismiss)

  return (
    <div className={cn('alert fade show', `alert-${type}`, {'alert-dismissible': isDismissible}, className)}>
      {children}
      {isDismissible && (
        <button type="button" className="close" onClick={onDismiss ?? defaultOnDismiss}>
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  )
}
